import styled from "styled-components";

export const CalendarBaseWrapper = styled.div<{ $theme?: string }>`
  margin-top: 10px;
  width: 100%;
  .fui-Calendar,
  .fui-Calendar__liveRegion,
  .fui-CalendarDay,
  .fui-CalendarDay__header,
  .fui-CalendarDayGrid__table,
  .fui-Calendar__monthPickerWrapper,
  .fui-CalendarPicker {
    width: 100%;
  }
  .fui-CalendarPicker__buttonRow {
    display: flex;
    justify-content: space-between;
  }
  .fui-Calendar__goTodayButton {
    margin-right: 0px;
    width: 100%;
  }
  .fui-CalendarDayGrid__daySingleSelected {
    display: flex;
    justify-content: center;
  }
  .fui-CalendarDayGrid__dayIsToday {
    display: flex;
    justify-content: center;
    width: 100%;
  }
  .fui-CalendarDay {
    padding: 0px !important;
  }
`;
